import React, { useEffect, useState } from "react";
import "../Count/Count.css";

const stats = [
  { label: "Client Consultations", value: 1000, suffix: "+" },
  { label: "Successful Cases", value: 95, suffix: "%" },
  { label: "Recovered cost for clients", value: 10, suffix: "m" },
  { label: "Professional Team", value: 30, suffix: "+" },
];

const CountBox = ({ value, label, suffix }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = value;
    const duration = 1500;
    const stepTime = Math.max(Math.floor(duration / end), 30);

    const timer = setInterval(() => {
      start += 1;
      setCount(start);

      if (start >= end) {
        clearInterval(timer);
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [value]);

  return (
    <div className="count-box">
      <div className="count-value">
        {count}
        {suffix}
      </div>
      <div className="count-label">{label}</div>
    </div>
  );
};

const CountSection = () => {
  return (
    <section className="count-section">
      {stats.map((stat, index) => (
        <CountBox
          key={index}
          value={stat.value}
          label={stat.label}
          suffix={stat.suffix}
        />
      ))}
    </section>
  );
};

export default CountSection;